<template>
  <div :class="['page', `page--step${$root.step}`]">
    <header class="page__header">
      <Header />
    </header>
    <section class="page__wrapper">
      <router-view />
    </section>
    <!--
    <footer class="page__footer">
      <Footer />
    </footer>
	<div class="page__extra_image">
	</div>
  -->
  </div>
</template>

<script>
  import Header from "@/components/header/Header.vue";
  /*import Footer from "@/components/footer/Footer.vue";*/
  //import QRCode from './js-components/qrcode.min.js';

  export default {
    components: { Header/*, Footer*/ }
  };

</script>

<script type="text/javascript">
(function(window, document, dataLayerName, id) {
window[dataLayerName]=window[dataLayerName]||[],window[dataLayerName].push({start:(new Date).getTime(),event:"stg.start"});var scripts=document.getElementsByTagName('script')[0],tags=document.createElement('script');
function stgCreateCookie(a,b,c){var d="";if(c){var e=new Date;e.setTime(e.getTime()+24*c*60*60*1e3),d="; expires="+e.toUTCString();f="; SameSite=Strict"}document.cookie=a+"="+b+d+f+"; path=/"}
var isStgDebug=(window.location.href.match("stg_debug")||document.cookie.match("stg_debug"))&&!window.location.href.match("stg_disable_debug");stgCreateCookie("stg_debug",isStgDebug?1:"",isStgDebug?14:-1);
var qP=[];dataLayerName!=="dataLayer"&&qP.push("data_layer_name="+dataLayerName),isStgDebug&&qP.push("stg_debug");var qPString=qP.length>0?("?"+qP.join("&")):"";
tags.async=!0,tags.src="https://boraselhandel.containers.piwik.pro/"+id+".js"+qPString,scripts.parentNode.insertBefore(tags,scripts);
!function(a,n,i){a[n]=a[n]||{};for(var c=0;c<i.length;c++)!function(i){a[n][i]=a[n][i]||{},a[n][i].api=a[n][i].api||function(){var a=[].slice.call(arguments,0);"string"==typeof a[0]&&window[dataLayerName].push({event:n+"."+i+":"+a[0],parameters:[].slice.call(arguments,1)})}}(i[c])}(window,"ppms",["tm","cm"]);
})(window, document, 'dataLayer', '69b04403-df7b-4b4e-82bd-1f47f4d9df4d');
</script>

<!--
<script type="text/javascript" src="js-components/boraselhandel-component-searchcontracts.js"></script>
<link rel="stylesheet" href="js-components/boraselhandel-component-searchcontracts.css" media="all" />
-->

<!--<script type="text/javascript" src="./js-components/qrcode.min.js"></script>-->

<style lang="scss">
  @import "~@/assets/scss/base";
  body {
    background: rgb(89, 92, 87)/*#57a3af*/ no-repeat 50%/cover;
  }
  .step__row {
      background-color:#f8f8f8;/*#fff0dd;*//*#f8f8f8;*/
      /*padding:1.33333rem;*/
      padding: 0.5em 1.33333rem;
      margin: 0.72222rem 0 1.33333rem;
      border: 1px solid #d6d6d6;    

      &__content {
        flex-basis: 50%;
        position: relative;
        margin: 0;
        @include media('>lg') {
          padding: rem(8) rem(16) rem(8) rem(32);
          font-size: rem(16);
        }
        @include media('<=lg') {
          padding: rem(8) 0 rem(8) rem(32);
          font-size: rem(15);
        }
        svg {
          position: absolute;
          left: 0;
          top: rem(16/2);
          width: rem(16);
          height: rem(16);
        }
        polygon {
          fill: $primary-color;
        }
      }
  }
  .page {
    background-color: #fff;
    border: 1px solid #000;
    margin: 0px auto;

    @include media('>lg') {
      padding: 0 rem(40);
      /*width: 50vw;*/
      width: 90%;
      max-width: 850px;
      min-height: 100vh;
      position: relative;
    }
    @include media('<=lg') {
      padding: 0 rem(16);
    }
    &__header {
      @include media('>lg') {
        margin: 0 rem(-40);
      }
      @include media('<=lg') {
        margin: 0 rem(-16);
      }
    }
    &__footer {
      @include media('>lg') {
        position: fixed;
        box-shadow: 0 0 8px 3px rgba(0, 0, 0, 0.06);
        z-index: 2;
        background: #fff;
        right: 1rem;
        top: 1rem;
      }
      @include media('<=lg') {
        background: $light-bg-color;
        margin: 0 rem(-16);
      }
    }
    @include media('>lg') {
      /*&:after {
        position: fixed;
        z-index: 1;
        right: 0;
        top: 0;
        bottom: 0;
        left: 50vw;
        content: '';
        background: $primary-color no-repeat 50% / cover;
      }*/
      @for $i from 1 through 9 {
        &--step#{$i} {
          /*
          &:after {
            background-image: url('~@/assets/images/backgrounds/step#{$i}.jpg');
            @media (min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
              background-image: url('~@/assets/images/backgrounds/step#{$i}@2x.jpg');
            }
            @media (min-device-pixel-ratio: 3), (min-resolution: 288dpi) {
              background-image: url('~@/assets/images/backgrounds/step#{$i}@3x.jpg');
            }
          }
          */
        }
      }
    }
    @include media('>lg') {
      &__extra_image {
        position: fixed;
        box-shadow: 0 0 8px 3px rgba(0, 0, 0, 0.06);
        z-index: 2;
        right: 1rem;
        bottom: 1rem;
		background: transparent no-repeat 50% / cover;
		width: 6rem;
		height: 6rem;
		background-image: url('~@/assets/images/schysst_elhandel.png');
		@media (min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
          background-image: url('~@/assets/images/schysst_elhandel@2x.png');
		}
		@media (min-device-pixel-ratio: 3), (min-resolution: 288dpi) {
          background-image: url('~@/assets/images/schysst_elhandel@3x.png');
		}		
      }
    }
    @include media('<=lg') {
      &__extra_image {
		display: none;
      }
    }
  }


boraselhandel-component-searchcontracts .textinput {
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom: 1px solid #555;
  width: 80%;
  text-align: center;
}

boraselhandel-component-searchcontracts .textinput:focus,
boraselhandel-component-searchcontracts .textinput:active {
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
}

boraselhandel-component-searchcontracts {
	width: 100%;
	clear: both;
	font-size: 1.2em;
	display: block;
	min-height: 150px;
}

.page__wrapper {
  margin-bottom: 400px;
}

boraselhandel-component-searchcontracts > .col {
  height: 100px;
  
    @include media('>=lg') {
      /*width: 19.99%;*/
      width: 24.99%;
      display: inline-block;
      float:left;
    }
    @include media('<lg') {
      width: 100%;
      display: block;
    }
	
	border: 1px solid #ccc;
  text-align: center;
  font-size: 1rem;
}

boraselhandel-component-searchcontracts > .hidetextonsmall {
  @include media('<=lg') {
    font-size: 0px;
  }
}

boraselhandel-component-searchcontracts > .col .title {
	font-weight: bold;
	padding-bottom: 20px;
  font-size: 1rem; /*16px;*/
  display: block;
}

boraselhandel-component-searchcontracts > .col .dateinputarea .dateinput {
	/*border: 1px solid #ccc;*/
	/*border-right-width: 0px;*/

  @include media('>=lg') {
	height:20px;
  }
  @include media('<lg') {
    height:40px;
  }

	display: inline-block;

  /*@include media('<lg') {
    font-size: 0.7vw;
  }*/
}

boraselhandel-component-searchcontracts > .col .dateinputarea .dateinputicon {
	border: 1px solid #ccc;
	border-left-width: 0px;
	display: inline-block;
	height: 20px;
}

boraselhandel-component-searchcontracts > .col.actionbutton {
	background-color: #57a3af;
}

@include media('>=lg') {
  boraselhandel-component-searchcontracts > .col.actionbutton button {
    margin-top: 15%;
    margin-left: 23%;
    background-color: #57a3af;
    border: 0px;
  }
}
@include media('<lg') {
  boraselhandel-component-searchcontracts > .col.actionbutton button {
    margin-top: 7%;
    margin-left: 40%;
    background-color: #57a3af;
    border: 0px;

    font-size: 1rem !important;
  }
}

 /* The switch - the box around the slider */
boraselhandel-component-searchcontracts > .col .switch {
  position: relative;
  display: inline-block;
  width: 54px;  /* 60 */
  height: 26px; /* 34 */
}

/* Hide default HTML checkbox */
boraselhandel-component-searchcontracts > .col .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
boraselhandel-component-searchcontracts > .col .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

boraselhandel-component-searchcontracts > .col .slider:before {
  position: absolute;
  content: "";
  height: 20px; /* 26 */
  width: 20px; /* 26 */
  left: 4px;
  bottom: 3px; /* 4 */
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

boraselhandel-component-searchcontracts > .col input:checked + .slider {
  background-color: #F28F91;
}

boraselhandel-component-searchcontracts > .col input:focus + .slider {
  box-shadow: 0 0 1px #F28F91;
}

boraselhandel-component-searchcontracts > .col input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
boraselhandel-component-searchcontracts > .col .slider.round {
  border-radius: 34px;
}

boraselhandel-component-searchcontracts > .col .slider.round:before {
  border-radius: 50%;
}   


.checkswitch {
  position: relative;
  display: inline-block;
  width: 54px;  /* 60 */
  height: 26px; /* 34 */
}

/* Hide default HTML checkbox */
.checkswitch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.checkswitch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.checkswitch .slider:before {
  position: absolute;
  content: "";
  height: 20px; /* 26 */
  width: 20px; /* 26 */
  left: 4px;
  bottom: 3px; /* 4 */
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

.checkswitch input:checked + .slider {
  background-color: #F28F91;
}

.checkswitch input:focus + .slider {
  box-shadow: 0 0 1px #F28F91;
}

.checkswitch input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.checkswitch .slider.round {
  border-radius: 34px;
}

.checkswitch .slider.round:before {
  border-radius: 50%;
} 

.checkswitchrow {
  line-height: 1.5;
  font-size: 0.88889rem;
  color: #595b56;
  display: block;
  position: relative;
  text-align: left;
}

.customernew__invoice-location {
  width: 100%;
}

</style>
